export default "__VITE_ASSET__AhU$6b5O__"